import React, { useState } from "react";
import PropTypes from "prop-types";
import Camera, { IMAGE_TYPES, FACING_MODES } from "react-html5-camera-photo";

import PicturePreview from "containers/UploadPictures/PicturePreview";
import CameraPortal from "./CameraPortal";
import dataURIToBlob from "utils/URIToBlob";
import { getRandomName } from "utils/global-utils";
import { CameraOverlay } from "./CameraOverlay";

import "react-html5-camera-photo/build/css/index.css";

export const CameraPhoto = ({
  isVisible,
  onTakePhoto,
  handleImage,
  closeCamera,
  ...props
}) => {
  const [preview, setPreview] = useState({});
  const selectPicture = photo => {
    const blobImage = dataURIToBlob(photo);
    const randomName = getRandomName() + "." + /[^/]*$/.exec(blobImage.type)[0];
    const photoFile = new File([blobImage], randomName, {
      type: blobImage.type
    });
    const payload = onTakePhoto(photoFile);
    setPreview({
      show: true,
      src: URL.createObjectURL(payload.target.files[0]),
      payload
    });
  };

  const closePreview = () => setPreview({});

  if (!isVisible) {
    return;
  }

  return (
    <CameraPortal>
      <CameraOverlay />
      <Camera
        {...props}
        isMaxResolution
        idealFacingMode={FACING_MODES.ENVIRONMENT}
        isImageMirror={false}
        imageCompression={0.9}
        onTakePhoto={selectPicture}
        imageType={IMAGE_TYPES.JPG}
      />
      {preview.show && (
        <PicturePreview
          closePreview={closePreview}
          handleImage={handleImage}
          closeCamera={closeCamera}
          isPreviewFromCamera
          {...preview}
        />
      )}
    </CameraPortal>
  );
};

CameraPhoto.propTypes = {
  onTakePhoto: PropTypes.func,
  isVisible: PropTypes.bool
};

CameraPhoto.defaultProps = {
  onTakePhoto: () => false,
  isVisible: true
};

export default CameraPhoto;
